import Big from "big.js";
import { t } from "i18next";
import { interpolateSinebow } from "d3-scale-chromatic";
import { AssetsType, PortfoliosType } from "../../store";

/**
 * Generates a "Portfolio [Letter]" portfolio name string
 * @param allPortfolios - the entire portfolios Object from Redux (state.portfolios)
 * @returns a portfolio name, such as "Portfólio A"
 */
export const generatePortfolioName = (
  allPortfolios: PortfoliosType
): string => {
  return `${t("portfolio")} ${Object.keys(allPortfolios).length + 1}`;
};

/**
 * Generates a unique visible distinct color using the portfolio[key]
 * @param portfolioKey - target portfolio key from Redux (state.portfolios[key])
 * @param allPortfolios - the entire portfolios Object from Redux (state.portfolios)
 * @returns a hexadecimal color, such as #00FAFA
 */
export const generatePortfolioColor = (
  portfolioKey: number,
  allPortfolios: PortfoliosType
): string => {
  /* eslint-disable */
  /* Sum all portfolios assets plus the portfolio itself (+ 1) to determine the number of colors needed plus 5 to account for benchmarks */
  const totalColors =
    Object.keys(allPortfolios).reduce(
      (acc, portfolioKey) =>
        acc + Object.keys(allPortfolios[Number(portfolioKey)].assets).length,
      0
    ) + 6;

  const calculatedColor = interpolateSinebow(portfolioKey / totalColors);

  return calculatedColor;
};

export const calculateAssetsTotalAmount = (
  assets: AssetsType | null,
  roundingDecimalPlaces = 16
): number => {
  if (assets !== null) {
    return Object.keys(assets)
      .reduce(
        (accumulator, currentAsset) =>
          accumulator.plus(Big(assets[currentAsset].amount || 0)),
        Big(0)
      )
      .round(roundingDecimalPlaces)
      .toNumber();
  }
  return 0;
};

export const calculateAssetsTotalPercentage = (
  assets: AssetsType | null,
  roundingDecimalPlaces?: number
): number => {
  if (assets !== null) {
    return Object.keys(assets)
      .reduce(
        (accumulator, currentAsset) =>
          accumulator.plus(Big(assets[currentAsset].percentage || 0)),
        Big(0)
      )
      .round(roundingDecimalPlaces)
      .toNumber();
  }
  return 0;
};
